import { Component, OnInit, inject } from '@angular/core';
import { EnvService } from '../../../../app/env.service';
import { NgStyle } from '@angular/common';

@Component({
  selector: 'app-maintenance',
  standalone: true,
  templateUrl: './maintenance.component.html',
  styleUrls: ['./maintenance.component.scss'],
  imports: [NgStyle],
})
export class MaintenanceComponent implements OnInit {
  private envService = inject(EnvService);

  tncAppVersionData: any;
  tncText: any;
  height: any;
  bgUrl: any;
  date = new Date();
  currentYear: any;

  ngOnInit() {
    // this.height = window.innerHeight+'px';
    this.bgUrl = this.envService.bloburl + '/careersite/Images/bg/pyramid.png';
    document.documentElement.style.setProperty('--dynamic-url', 'url(' + this.bgUrl + ') 100%');
    this.currentYear = this.date.getFullYear();
  }
}
